export enum EFiltersState {
    all = 0,
    currents = 1
}